export default __webpack_public_path__ + "static/media/H258f066029b644848a28b3df5d7d24cbL.png_.413be767.webp";